<template>
    <multiple-image-cta-section
        class="multiple-image-cta-section-module"
        :items="formattedCtas"
    />
</template>

<script>
    import MultipleImageCtaSection from '../../../organisms/MultipleImageCtaSection/MultipleImageCtaSection';
    import formatMediaObject from '../../../../utils/formatters/format-media-object';

    export default {
        name: 'multiple-image-cta-section-module',

        components: { MultipleImageCtaSection },

        props: {
            attributes: {
                type: Object,
                required: true,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Format the api data for the MultipleImageCtaSection component.
             *
             * @returns {Array}
             */
            formattedCtas() {
                return (this.attributes.image_text_link || []).map(({ id, text, image, link, link_external }) => ({
                    id,
                    text,
                    image: formatMediaObject.call(this, image),
                    to: link
                        ?.uri,
                    href: link_external,
                }));
            },
        },
    };
</script>
